import { html } from '@shared/utils/rendering/html';
import { useRef } from 'preact/hooks';

import Button from '@shared/components/buttons';
import { LoaderWithTitle } from '@shared/components/loading';

import { useCachedFetch } from '@core/utils/hooks/use-cached-fetch';
import EditSystemsForm from './edit-systems-form';
import ApiKeys from '../api-keys';
import ApiKeysTableProvider from '../api-keys/context/api-keys.context';

const SystemDetails = ({ remoteSystemId }) => {
    const systemFormRef = useRef(null);

    const { data: systemData, isLoading } = useCachedFetch(`/systems/${remoteSystemId}`, {});

    const fetchSystemsKey = [`/systems/${remoteSystemId}`, {}];

    const handleReset = () => systemFormRef?.current?.reset();
    const handleSubmit = (event) => systemFormRef?.current?.submit(event);

    if (isLoading) {
        return html`<${LoaderWithTitle} busyLoading=${true} title="Loading system details..." />`;
    }

    if (!systemData) {
        return html`<div class="error-page">System not found</div>`;
    }

    return html`
        <${EditSystemsForm} ref=${systemFormRef} rowData=${systemData} fetchSystemsKey=${fetchSystemsKey} />

        <${ApiKeysTableProvider}>
            <${ApiKeys} selectedSystem=${systemData} remoteSystemId=${remoteSystemId} />
        </${ApiKeysTableProvider}>

        <div class="card">
            <div class="card-footer">
                <${Button}
                    buttonType="secondary"
                    label=${{ text: 'Reset' }}
                    onClick=${handleReset}
                />
                <${Button}
                    buttonType="primary"
                    label=${{ text: 'Save' }}
                    onClick=${handleSubmit}
                />
            </div>
        </div>
    `;
};

export default SystemDetails;
